import React, { useContext, useCallback } from 'react';
import classNames from 'classnames';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { MarkAsShippedContext } from '../../../context';

import baseStyle from '../../style.module.less';
import style from './style.module.less';

const messages = defineMessages({
  removeText: {
    description: 'Mark as shipped remove button',
    defaultMessage: 'Remove',
    id: 'k5ndKY',
  },
});

const Carrier = () => {
  const { bulkRemoveFulfillmentPlans } = useContext(MarkAsShippedContext);

  const onClick = useCallback(
    (event) => {
      event.stopPropagation();
      bulkRemoveFulfillmentPlans();
    },
    [bulkRemoveFulfillmentPlans],
  );

  return (
    <div className={classNames(baseStyle['bulk-update-item'], style['remove-button'])}>
      <Button onClick={onClick} theme='link'>
        <FormattedMessage {...messages.removeText} />
      </Button>
    </div>
  );
};

export default Carrier;
